import React from "react";
import { Col, Form, Placeholder, Row } from "react-bootstrap";
import MainCard from "../Cards/MainCard";

const ApiKeyFormSkeleton = () => {
  return (
    <MainCard>
      <Form>
        <Row>
          {/* Stripe API Key */}
          <Col lg={4} md={4} sm={12} className="mb-3">
            <Placeholder as="h6" animation="wave" className="mb-1">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder
              as="div"
              animation="wave"
              className="rounded w-100"
              style={{ height: "38px" }}
            />
          </Col>

          {/* PayPal Client ID */}
          <Col lg={4} md={4} sm={12} className="mb-3">
            <Placeholder as="h6" animation="wave" className="mb-1">
              <Placeholder xs={6} />
            </Placeholder>
            <Placeholder
              as="div"
              animation="wave"
              className="rounded w-100"
              style={{ height: "38px" }}
            />
          </Col>

          {/* Square Application ID */}
          <Col lg={4} md={4} sm={12} className="mb-3">
            <Placeholder as="h6" animation="wave" className="mb-1">
              <Placeholder xs={7} />
            </Placeholder>
            <Placeholder
              as="div"
              animation="wave"
              className="rounded w-100"
              style={{ height: "38px" }}
            />
          </Col>
        </Row>

        {/* Buttons */}
        <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-3">
          <Placeholder.Button variant="primary" xs={3} className="me-2" />
          <Placeholder.Button variant="secondary" xs={4} />
        </div>
      </Form>
    </MainCard>
  );
};

export default ApiKeyFormSkeleton;
